import { AfterViewChecked, Component, ElementRef, NgZone, OnDestroy, OnInit, computed, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import _ from 'lodash';
import { combineLatest, of } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';
import { ChatClientService } from 'stream-chat-angular';
import { RouterStateService } from '../../../core/routing/router-state.service';
import { AppSettingsService } from '../../../core/services/app-settings.service';
import { BadgesService } from '../../../core/services/badges.service';
import { CataloguesService } from '../../../core/services/catalogues.service';
import { EstimatesV2Service } from '../../../core/services/estimateV2.service';
import { IntercomService } from '../../../core/services/intercom.service';
import { LaunchDarklyService } from '../../../core/services/launchdarkly.service';
import { LeadsService } from '../../../core/services/leads.service';
import { MessagingService } from '../../../core/services/messaging.service';
import { NotificationService } from '../../../core/services/notification.service';
import { FeatureService } from '../../../core/services/permission/feature.service';
import { PermissionService } from '../../../core/services/permission/permission.service';
import { TriallerService } from '../../../core/services/trialler.service';
import { RepoContactsService } from '../../../data/repositories/repo-contacts.service';
import { RepoIntegrationsService } from '../../../data/repositories/repo-integrations.service';
import { RepoSettingsService } from '../../../data/repositories/repo-settings.service';
import { SharedDataService } from '../../../data/services/shared-data.service';
import { UserAvatarInfo } from '../../../shared/bx-user-avatar';
import { MaterialOrdersStoreService } from '../../../shared/material-orders/domain/material-orders.store.service';
import { MaterialOrdersNavigatorService } from '../../../shared/material-orders/material-orders-navigator/material-orders-navigator.service';
import { TodoStore } from '../../../shared/todo-list/domain/todo.store.service';
import { TodoNavigatorService } from '../../../shared/todo-list/todo-navigator/todo-navigator.service';
import { toCamelCaseProps } from '../../../utils/helper-functions/string.functions';
import { AiEstimateStoreService } from '../../estimates/estimate-create/create-smart-estimate/domain/services/ai-estimate-store.service';
import { NotificationApiService } from '../../messages/notifications/domain/apis/notification-api.service';
import { QuoteRequestsService } from '../../quoterequests/quoterequest.service';
import { LayoutService } from '../layout.service';
import { BxLogger } from './../../../core/services/bx-logger.service';
import { StoresService } from './../../../core/services/stores/stores.service';
import { AccountIntegrationsStoresService } from './../../account/integrations/feat-account-integrations/domain/apis/account-integrations.stores';
import { ConnectionDetailsStores } from './../../integrations-v2/connection-details/domain/apis/connection-details.stores';
import { Sidebar2SubpanelSharedService } from './sidebar2-subpanel-shared.service';
import { Sidebar2ToggleService } from './sidebar2-toggle.service';

@UntilDestroy()
@Component({
    selector: 'app-sidebar2',
    styleUrls: ['./sidebar2.component.scss'],
    templateUrl: './sidebar2.component.html',
    standalone: false,
})
export class Sidebar2Component implements OnInit, OnDestroy, AfterViewChecked {
    combinedMessageBadgeCount = 0;
    badgeCounts: any = {
        estimates: 0,
        applicationIntegrations: 0,
        jobs: 0,
        integrations: 0,
    };
    // @ts-ignore TS2564
    mobileView: boolean;
    submenuStatus = {
        leads: true,
        estimates: true,
        jobs: true,
        quoterequests: true,
        clients: true,
        contacts: true,
        communications: true,
        catalogues: true,
        integrations: true,
        profile: true,
        chat: true,
        explore: true,
        mybusiness: true,
    };
    toggle_Connections = true;
    integrationsErrors = false;
    states: any = {};

    routerUrl: string = '';

    $state: any = '';
    $stateParams: any = {};
    // @ts-ignore TS7008
    allowIntegrations;
    // @ts-ignore TS7008
    requestedCount;
    // @ts-ignore TS7008
    updateUnreadCounts;
    // @ts-ignore TS7008
    firstNameWatcherUnbind;
    // @ts-ignore TS7008
    lastNameWatcherUnbind;
    // @ts-ignore TS7008
    loadUnreadMessagesThrottled;
    // @ts-ignore TS7008
    subRefreshAccountIntegrations;
    // @ts-ignore TS7008
    accountOptions;
    // @ts-ignore TS7008
    importingItems;
    // @ts-ignore TS7008
    Initials;
    // @ts-ignore TS7008
    loadingIntegrations;
    // @ts-ignore TS7008
    integrationsNotificationsCount;
    // @ts-ignore TS7008
    integrationsActive;
    // @ts-ignore TS7008
    filterState;
    // @ts-ignore TS7008
    communicationsOptions;
    // @ts-ignore TS2564
    canSeeIntercom: boolean;
    showRfqMenuOption = false;
    showAPIWebhooks = false;

    importProgressUpdatedHandler = this.importProgressUpdated.bind(this);
    incomingConnectionsCountUpdatedHandler = this.incomingConnectionsCountUpdated.bind(this);
    clientConnectionsAckUpdatedHandler = this.clientConnectionsAckUpdated.bind(this);
    handleDataChangedHandler = this.handleDataChanged.bind(this);
    streamChatInitHandler = this.streamChatInit.bind(this);
    // @ts-ignore TS2564
    logoUrl: string;

    isSidebarClosed$ = this.layoutService.isSidebarClosed$;
    avatarInfo?: UserAvatarInfo;
    todoNavigator = inject(TodoNavigatorService);
    isTodoAvailable = inject(TodoStore).staticData.flags.menu;
    readonly #aiEstimateStoreService = inject(AiEstimateStoreService);
    processingSmartEstimate = this.#aiEstimateStoreService.processingEstimate;
    readonly #materialOrdersStoreService = inject(MaterialOrdersStoreService);
    materialOrdersNavigator = inject(MaterialOrdersNavigatorService);
    isMaterialOrdersMenuAvailable = computed(
        () =>
            this.#materialOrdersStoreService.staticData.flags.menu() &&
            this.#materialOrdersStoreService.staticData.flags.isFeatureAvailable() &&
            this.#materialOrdersStoreService.staticData.flags.hasOrderingProviderAvailable()
    );

    withSeeMore = signal(false);
    showMore = signal(false);
    exploreMoreWithResources = signal(false);
    #resizeAbortController = new AbortController();
    #notificationApiService = inject(NotificationApiService);

    constructor(
        public appSettings: AppSettingsService,
        public featureService: FeatureService,
        private elRef: ElementRef,
        public permissionService: PermissionService,
        private intercomService: IntercomService,
        private leadsService: LeadsService,
        private badgesService: BadgesService,
        private sidebar2SubpanelSharedService: Sidebar2SubpanelSharedService,
        private sidebar2toggle: Sidebar2ToggleService,
        private storesService: StoresService,
        private connectionDetailsStores: ConnectionDetailsStores,
        private messagingService: MessagingService,
        private accountIntegrationsStoresService: AccountIntegrationsStoresService,
        private logger: BxLogger,
        private layoutService: LayoutService,
        public lds: LaunchDarklyService,
        public sharedData: SharedDataService,
        public settings: RepoSettingsService,
        private integrationsRepo: RepoIntegrationsService,
        private notificationService: NotificationService,
        private cataloguesService: CataloguesService,
        private estimatesService: EstimatesV2Service,
        private quoteRequestService: QuoteRequestsService,
        private triallerService: TriallerService,
        private chatService: ChatClientService,
        private ngZone: NgZone,
        private router: Router,
        private routerStateService: RouterStateService,
        private repoContacts: RepoContactsService
    ) {}

    ngOnInit() {
        this.routerStateService.routeChanged$.pipe(untilDestroyed(this)).subscribe((e) => {
            this.routerUrl = this.routerStateService.currentUrl ?? '';
        });

        this.setupFeaturesData();
        this.featureService.featuresRebuilt.pipe(untilDestroyed(this)).subscribe(() => {
            this.setupFeaturesData();
        });

        this.showMore.set(this.settings.sidebarSeeMore);

        this.storesService.userAvatarUrl$.pipe(untilDestroyed(this)).subscribe((avatarUrl) => {
            // Cannot do this in userService, UserData.user is re-written by some staging in login
            this.sharedData.UserData.user.avatar = avatarUrl;
            this.#loadUserAvatarInfo();
        });
        this.storesService.updateInitials$.pipe(untilDestroyed(this)).subscribe(() => {
            this.#loadUserAvatarInfo();
        });

        this.mobileView = this.layoutService.isMobile();
        window.addEventListener('resize', () => (this.mobileView = this.layoutService.isMobile()), {
            signal: this.#resizeAbortController.signal,
        });
        this.canSeeIntercom = this.lds.get('communications.intercom') ?? false;
        this.showAPIWebhooks = this.permissionService.isAvailable('api.webhooks-get');
        this.exploreMoreWithResources.set(this.lds.get('explore-more-with-resources'));

        this.storesService.refreshNotice$.subscribe(() => {
            this.getBadgeCount();

            // Wait a random interval up to 2 minutes, so that if many clients get
            // reconnected at once we do not flood the backend with concurrent requests
            setTimeout(
                () => {
                    this.updateBadges();
                },
                Math.floor(Math.random() * 120 * 1000)
            );
        });

        // Set up the initial options for this based on route...
        this.settings.ShowExplorePanel = false;
        this.settings.ChatActive = false;
        this.settings.ShowMyProfilePanel = false;
        this.settings.ShowIntegrationsPanel = false;

        this.loadUnreadMessagesThrottled = _.throttle(this.loadUnreadMessages.bind(this), 30 * 1000, { leading: true, trailing: true });

        /** BX-239 - Hook into individual integrations directive controllers sync events...*/
        this.subRefreshAccountIntegrations = this.accountIntegrationsStoresService.refreshAccountIntegrations$.subscribe(() => {
            this.integrationsSync();
        });

        this.registerEventHandlers();

        this.accountOptions = this.sidebar2SubpanelSharedService.getAccountOptions();

        this.storesService.syncIntegrations$.subscribe(() => {
            this.integrationsSync();
        });

        this.storesService.eventStatus$.subscribe((status: signalR.HubConnectionState) => {
            if (status) {
                this.deregisterEventHandlers.bind(this);
            }
        });

        this.getBadgeCount();
        this.loadUnreadMessages();
        this.intercomService.initUser();
        this.integrationsSync();
        this.sidebar2toggle.getInitialState();
        this.setNotificationBadges();
        this.setLogoUrl();

        if (this.lds.get('navigation-options-hide') && this.triallerService.isTrialler()) {
            this.updateShowRfqMenuOption();
        } else {
            this.showRfqMenuOption = true;
        }

        this.repoContacts.GetCardStatus();
        // badge counts for all modules
        //  this.getBadgeCount();
    }

    ngOnDestroy() {
        /* BX-210 - add a listener for when status is changed in purchase orders and invoices as per Matt's suggestion */

        if (this.subRefreshAccountIntegrations) {
            this.subRefreshAccountIntegrations.unsubscribe();
        }

        // Must add this on controller destruction to stop listening for signalr events

        this.deregisterEventHandlers();
        this.chatService.disconnectUser();
        this.#resizeAbortController.abort();
    }

    ngAfterViewChecked() {
        // Add sidebar collapsed class to body
        if (this.elRef.nativeElement.classList.contains('sidebar-collapsed')) {
            document.body.classList.add('app-sidebar-collapsed');
        } else {
            document.body.classList.remove('app-sidebar-collapsed');
        }
    }

    setupFeaturesData() {
        this.withSeeMore.set(!this.featureService.isAvailable('advance-side-navigation'));

        const accountIntegrationsStatuses = this.featureService.getStatuses([
            'account.integrations.applications',
            'account.integrations.suppliers',
            'account.integrations.addons',
        ]);
        const manufacturerState = this.featureService.getState('manufacturer');
        const viewCatalogueState = this.permissionService.getState('catalogues.maintain-catalogues.view-catalogue');

        combineLatest([accountIntegrationsStatuses, manufacturerState, viewCatalogueState])
            .pipe(
                switchMap(([accountIntegrationsStatuses, manufacturerState, isViewCatalogueAvailable]) => {
                    const allStates = {
                        accountIntegrationsApplications: accountIntegrationsStatuses.find(
                            (ps) => ps.key === 'account.integrations.applications'
                        )?.status,

                        accountIntegrationsSuppliers: accountIntegrationsStatuses.find((ps) => ps.key === 'account.integrations.suppliers')
                            ?.status,

                        accountIntegrationsAddons: accountIntegrationsStatuses.find((ps) => ps.key === 'account.integrations.addons')
                            ?.status,
                        manufacturer: manufacturerState,
                        cataloguesMaintainView: isViewCatalogueAvailable,
                        incomingIntegrationConnectionCountsResponse: undefined,
                    };
                    if (isViewCatalogueAvailable) {
                        return this.cataloguesService.getIncomingIntegrationConnectionCounts().valueChanges.pipe(
                            map((incomingIntegrationConnectionCountsResponse) => {
                                return {
                                    ...allStates,
                                    incomingIntegrationConnectionCountsResponse: incomingIntegrationConnectionCountsResponse,
                                };
                            })
                        );
                    } else return of(allStates);
                }),
                first()
            )
            .subscribe((response) => {
                this.states = response;

                this.allowIntegrations =
                    response.accountIntegrationsApplications ||
                    (response.accountIntegrationsSuppliers && !response.manufacturer) ||
                    response.accountIntegrationsAddons;

                if (response.incomingIntegrationConnectionCountsResponse) {
                    const connectionStatuses =
                        response.incomingIntegrationConnectionCountsResponse.data.incomingIntegrationConnectionCounts.map((x: any) => {
                            return { status: x.status.toLowerCase(), count: x.count };
                        });
                    const requestedStatus = connectionStatuses.find((x) => x.status === 'requested');
                    this.requestedCount = requestedStatus?.count;
                }

                this.updateBadges();
            });

        if (this.featureService.isAvailable('clientportal')) {
            // @ts-ignore TS7006
            this.updateUnreadCounts = (unreadCount) => {
                this.sharedData.UnreadCounts.conversations = unreadCount;
                this.combinedMessageBadgeCount =
                    this.sharedData.UnreadCounts.emails +
                    this.sharedData.UnreadCounts.messages +
                    this.sharedData.UnreadCounts.conversations;
                this.storesService.updateNotificationsCount();
                this.setNotificationBadges();
            };

            this.leadsService.hasAnyAcceptedClientPortalInvites().subscribe((res) => {
                // @ts-ignore TS2571
                const hasAnyAcceptedClientPortalInvites = res.data['hasAnyAcceptedClientPortalInvites'];
                if (hasAnyAcceptedClientPortalInvites) {
                    //the tenant has some published leads that have accepted invites, so lets initialize streamchat
                    this.streamChatInit();
                } else {
                    //the tenant doesn't have any published leads right now, but if they publish one then lets turn on streamchat right away
                    this.notificationService.connection.on('LeadsInviteStatusChanged', this.streamChatInitHandler);
                }
            });
        }
    }

    updateBadges() {
        if (this.states.cataloguesMaintainView) {
            this.cataloguesService.getCatalogueStatusData().then((response: any) => {
                this.importingItems = response.data.isCatalogueImportInProgress;
                if (response.data.unacknowledgedClientConnections) {
                    this.sharedData.UnacknowledgedConnections = response.data.unacknowledgedClientConnections;
                    this.connectionDetailsStores.unacknowledgedConnections = this.sharedData.UnacknowledgedConnections;
                    this.refreshIntegrationNotificationsCount();
                }
            });
        }
    }

    getBadgeCount() {
        this.badgesService.getBadgeCount().subscribe((response) => {
            if (response?.data?.badges) {
                this.badgeCounts = { ...response.data.badges };
            }
        });
    }

    streamChatInit() {
        this.messagingService.getMessagingUser().subscribe(async (res) => {
            const messagingUser = res.data['messagingUser'];
            this.chatService.events$.pipe(untilDestroyed(this)).subscribe((e) => {
                this.ngZone.run(() => {
                    switch (e.event.type) {
                        case 'message.new':
                        case 'notification.message_new':
                        case 'notification.mark_read':
                            this.updateUnreadCounts(e.event.total_unread_count);
                            break;
                    }
                });
            });
            this.chatService.user$.pipe(first()).subscribe((e) => {
                if (e !== undefined && 'total_unread_count' in e) {
                    this.updateUnreadCounts(e?.total_unread_count || 0);
                }
            });
            await this.chatService.init(
                window.APP_CONFIG.streamChatApiKey!,
                { id: messagingUser.id, name: messagingUser.name },
                messagingUser.token
            );
        });
    }

    /* AKA Panels that are toggle panels, without routes */
    RouteLessPanels() {
        return this.settings.ShowExplorePanel || this.settings.ShowMyProfilePanel || this.settings.ShowIntegrationsPanel;
    }

    subscribe() {
        this.router.navigate(['/account', 'subscription']);
    }

    resetMobileToggleStates() {
        // @ts-ignore TS7053
        Object.keys(this.submenuStatus).map((x) => (this.submenuStatus[x] = false));
    }

    // @ts-ignore TS7006
    getPrimaryLink(parentRoute) {
        // @ts-ignore TS7052
        let previousRoute = this.settings[`NavigationV2${parentRoute}RoutePath`];

        const activeRoute = this.routerStateService.currentRoute;
        if (!activeRoute) return;

        this.togglePanels();

        // @ts-ignore TS7052
        const params = JSON.parse(this.settings[`NavigationV2${parentRoute}Params`]);

        if (activeRoute.queryParams.subpanel !== undefined) {
            if (!this.mobileView) params.subpanel = activeRoute.queryParams.subpanel === 'false';
        }

        // This code is to toggle the subpanel in the same view. The previous route and current route may not be an exact match with new angular components.
        // Even though the current route may be estimates.list it's resolved to estimates.list2 in the route file for the new components so we need to match it.
        if (!this.routerStateService.currentUrl?.includes(previousRoute)) {
            params.open = 'true';
            params.subpanel = true;
            // for mobile view
            if (this.mobileView) {
                // @ts-ignore TS7053
                Object.keys(this.submenuStatus).map((x) => (this.submenuStatus[x] = false));
                // @ts-ignore TS7053
                this.submenuStatus[parentRoute.toLowerCase()] = true; // default sub menu to true for mobile view
            }
        } else {
            if (activeRoute.queryParams.subpanel == undefined) {
                params.subpanel = true;
            }
            if (
                this.mobileView &&
                this.routerStateService.currentUrl?.includes(previousRoute) &&
                activeRoute.queryParams.submenu === params.submenu
            ) {
                // if its mobile view and the same route, toggle submenu and do nothing else.
                // if the submenus are different, then we need to continue to load the route.
                const submenu = parentRoute.toLowerCase();
                // @ts-ignore TS7053
                this.submenuStatus[submenu] = !this.submenuStatus[submenu];
                if (submenu === 'integrations') {
                    this.settings.ShowIntegrationsPanel = !this.settings.ShowIntegrationsPanel;
                    if (this.settings.ShowIntegrationsPanel) {
                        this.storesService.setupSubpanels();
                    }
                }
                return;
            }
        }

        switch (parentRoute) {
            case 'MyBusiness' /* Radios */:
                switch (previousRoute) {
                    case '/account/details':
                    case '/account/users':
                    case '/account/subscription':
                        if (this.settings.NavigationV2MyBusinessBusinessAccountChoice)
                            params.choice = this.settings.NavigationV2MyBusinessBusinessAccountChoice;
                        break;
                    case '/account/api/webhooks':
                    case '/account/api/eventlog':
                        if (this.settings.NavigationV2MyBusinessBusinessApiChoice)
                            params.choice = this.settings.NavigationV2MyBusinessBusinessApiChoice;
                        break;
                    default:
                        if (this.settings.NavigationV2MyBusinessBusinessSetupChoice)
                            params.choice = this.settings.NavigationV2MyBusinessBusinessSetupChoice;
                        break;
                }
                break;
            case 'Estimates' /* Checkboxes */:
                switch (previousRoute) {
                    case '/estimates/list':
                        if (params.submenu === 'estimates') {
                            if (this.settings.NavigationV2EstimatesStatusSelections)
                                params.status = this.settings.NavigationV2EstimatesStatusSelections;
                        }
                        break;
                }
                break;
            case 'Leads' /* Checkboxes */:
                switch (previousRoute) {
                    case '/leads/list':
                        if (params.submenu === 'leads') {
                            if (this.settings.NavigationV2LeadsStatusSelections)
                                params.status = this.settings.NavigationV2LeadsStatusSelections;
                        }
                        break;
                }
                break;
            case 'Jobs' /* Checkboxes */:
                switch (previousRoute) {
                    case '/jobs/list':
                        if (this.settings.NavigationV2JobsStatusSelections) params.status = this.settings.NavigationV2JobsStatusSelections;
                        params.submenu = 'jobs';
                        // if transition from invoice or order to jobs then toggle.
                        if (this.mobileView && this.routerStateService.currentRouteName?.includes('jobs')) this.submenuStatus.jobs = false;
                        break;
                    case '/jobs/orders':
                        if (this.settings.NavigationV2JobsOrderStatusSelections)
                            params.status = this.settings.NavigationV2JobsOrderStatusSelections;
                        params.submenu = 'orders';
                        break;
                    case '/jobs/invoices':
                        if (this.settings.NavigationV2JobsInvoiceStatusSelections)
                            params.status = this.settings.NavigationV2JobsInvoiceStatusSelections;
                        params.submenu = 'invoices';
                        break;
                }
                break;
            case 'QuoteRequests' /* Checkboxes */:
                switch (previousRoute) {
                    case '/quoterequests/list':
                        if (this.settings.NavigationV2QuoteRequestsStatusSelections)
                            params.status = this.settings.NavigationV2QuoteRequestsStatusSelections;
                        params.submenu = 'request-for-quotes';
                        break;
                }
                break;
            case 'Clients' /* Checkboxes */:
                switch (previousRoute) {
                    case '/customers/list':
                        if (this.settings.NavigationV2ClientsStatusSelections)
                            params.type = this.settings.NavigationV2ClientsStatusSelections;
                        params.submenu = 'clients';
                        break;
                    case '/customers/connections':
                        if (this.settings.NavigationV2ClientConnectionsStatusSelections)
                            params.type = this.settings.NavigationV2ClientConnectionsStatusSelections;
                        params.submenu = 'connections';
                        break;
                }
                break;
            case 'Contacts' /* Checkboxes */:
                switch (previousRoute) {
                    case '/contacts/list':
                        if (this.settings.NavigationV2ContactsStatusSelections)
                            params.group = this.settings.NavigationV2ContactsStatusSelections;
                        params.submenu = 'contacts';
                        break;
                }
                break;
            case 'Catalogues' /* Radios */:
                switch (previousRoute) {
                    case '/price/price-list':
                        if (!params.list) {
                            params.list = 'Buildxact Recipes';
                        }
                        break;
                    default:
                        // let storedParams = this.settings.NavigationV2CataloguesParams
                        if (this.settings.NavigationV2CataloguesRecipesChoice)
                            params.choice = this.settings.NavigationV2CataloguesRecipesChoice;
                        params.submenu = 'recipes';
                        break;
                }
                break;
            case 'Communications':
                if (this.settings.NavigationV2CommunicationsChoice) params.choice = this.settings.NavigationV2CommunicationsChoice;
                this.setNotificationBadges();
                break;
            case 'Integrations':
                params.submenu = 'integrations';
                this.settings.ShowIntegrationsPanel = true;
                this.storesService.setupSubpanels();
                const previousChoice = this.settings.NavigationV2IntegrationsV2RouteChoice || previousRoute;
                if (
                    (previousChoice === this.settings.NavigationV2IntegrationsRoutePath &&
                        !this.featureService.isStateAvailable('account.integrations.applications')) ||
                    (previousChoice == this.settings.NavigationV2IntegrationsAddOnsRoutePath &&
                        !this.lds.get('integrations-addon-marketplace'))
                ) {
                    previousRoute = this.settings.NavigationV2IntegrationsV2RoutePath;
                } else {
                    previousRoute = previousChoice;
                }
        }

        // @ts-ignore TS7052
        this.settings[`NavigationV2${parentRoute}Params`] = JSON.stringify(params);

        this.router.navigate([previousRoute], { queryParams: params });
    }

    // @ts-ignore TS7006
    togglePanels(routeName?) {
        this.intercomService.hide();

        this.settings.ShowExplorePanel = false;
        this.settings.ChatActive = false;
        this.settings.ShowMyProfilePanel = false;
        this.settings.ShowIntegrationsPanel = false;
        if (this.mobileView && this.routerUrl.startsWith('/dashboard')) this.resetMobileToggleStates();
    }

    fnShowExplorePanel() {
        this.intercomService.hide();

        this.storesService.resetExplore();

        this.settings.ChatActive = false;
        this.settings.ShowMyProfilePanel = false;
        this.settings.ShowIntegrationsPanel = false;
        this.settings.ShowExplorePanel = !this.settings.ShowExplorePanel;
        this.resetMobileToggleStates();

        if (!this.mobileView) this.routerStateService.reloadCurrent({ subpanel: this.settings.ShowMyProfilePanel });
    }

    clearPanels() {
        this.settings.ShowExplorePanel = false;
        this.settings.ShowMyProfilePanel = false;
        this.settings.ShowIntegrationsPanel = false;
        this.resetMobileToggleStates();
    }

    showMaterialOrders() {
        this.materialOrdersNavigator.showList.set(true);
    }

    showTodoList() {
        this.todoNavigator.showList.set(true);
    }

    fnShowMyProfilePanel() {
        this.intercomService.hide();

        this.settings.ShowExplorePanel = false;
        this.settings.ShowIntegrationsPanel = false;
        this.settings.ChatActive = false;
        // this.settings.ShowMyProfilePanel = this.stateParams.subpanel = !this.settings.ShowMyProfilePanel
        this.settings.ShowMyProfilePanel = !this.settings.ShowMyProfilePanel;
        if (this.settings.ShowMyProfilePanel) {
            this.storesService.setupSubpanels();
        }
        this.resetMobileToggleStates();

        if (!this.mobileView) this.routerStateService.reloadCurrent({ subpanel: this.settings.ShowMyProfilePanel });
    }

    fnShowIntegrationsPanel() {
        this.intercomService.hide();

        this.settings.ShowExplorePanel = false;
        this.settings.ShowMyProfilePanel = false;
        this.settings.ChatActive = false;
        // this.settings.ShowIntegrationsPanel = this.stateParams.subpanel = !this.settings.ShowIntegrationsPanel
        this.settings.ShowIntegrationsPanel = !this.settings.ShowIntegrationsPanel;
        if (this.settings.ShowIntegrationsPanel) {
            this.storesService.setupSubpanels();
        }

        this.routerStateService.reloadCurrent({ subpanel: this.settings.ShowIntegrationsPanel });
    }

    loadUnreadMessages() {
        this.#notificationApiService
            .getUnreadMessageCount()
            .pipe(first())
            .subscribe((result) => {
                const dataChangeCount = this.#unreadCountChangeCheck(result, 'messages');
                this.#unreadCountBadgeBroadcast(dataChangeCount > 0);
            });
    }

    #unreadCountBadgeBroadcast(hasChanges: boolean) {
        this.combinedMessageBadgeCount =
            this.sharedData.UnreadCounts.emails + this.sharedData.UnreadCounts.messages + this.sharedData.UnreadCounts.conversations;
        if (hasChanges) {
            this.storesService.updateNotificationsCount();
            this.setNotificationBadges();
        }
    }

    #unreadCountChangeCheck(count: number, type: 'emails' | 'messages'): number {
        let dataChangeCount = 0;
        if (this.sharedData.UnreadCounts[type] !== count) {
            this.sharedData.UnreadCounts[type] = count;
            dataChangeCount++;
        }
        return dataChangeCount;
    }

    integrationsSync() {
        if (!this.loadingIntegrations) {
            this.loadingIntegrations = true;
            this.integrationsRepo.Get().then((result) => {
                this.sharedData.Integrations = result.data;
                this.accountIntegrationsStoresService.integrations = result.data;
                this.refreshIntegrationNotificationsCount();
                this.determineVisibilityOfConnections();
                this.accountIntegrationsStoresService.completeSyncIntegration();
            });
        }
    }

    // @ts-ignore TS7006
    importProgressUpdated(progress) {
        this.importingItems = progress ? !progress.OverallProgressComplete : false;
    }

    // Triggered by signalR
    // @ts-ignore TS7006
    incomingConnectionsCountUpdated(update) {
        const connectionStatuses = update ? update.Statuses : [];
        // @ts-ignore TS7006
        if (connectionStatuses) connectionStatuses.map((x) => (x.Status = x.Status.toLowerCase()));
        // @ts-ignore TS7006
        const requestedStatus = connectionStatuses.find((x) => x.Status === 'requested');

        /*
                We check if the connection type is SupplierInviteClient so that we can
                badge the Integrations menu item.
                Otherwise, badges the Clients menu item
            */
        if (update?.ConnectionType !== 2) {
            this.requestedCount = requestedStatus ? requestedStatus.Count : 0;

            this.storesService.refreshCustomers();
        }
    }

    refreshIntegrationNotificationsCount() {
        this.loadingIntegrations = false;
        this.integrationsErrors = false;
        this.integrationsNotificationsCount = 0;

        if (!this.sharedData.Integrations) {
            return;
        }

        this.sharedData.Integrations.map((r) => {
            if (r.status.state !== 'NotConnected' && r.status.state !== 'Error') {
                this.integrationsNotificationsCount += r.status.notifications;
            }
            if (r.status.state === 'Error' || r.status.state === 'Attention') {
                this.integrationsNotificationsCount = 0;
                this.integrationsErrors = true;
            }
        });
    }

    // @ts-ignore TS7006
    clientConnectionsAckUpdated(clientConnectionsAckUpdated) {
        const connections = clientConnectionsAckUpdated ? clientConnectionsAckUpdated.Connections : [];
        this.sharedData.UnacknowledgedConnections = toCamelCaseProps(connections);

        for (let i = 0; i < this.sharedData.UnacknowledgedConnections.length; i++) {
            // @ts-ignore TS2532
            this.sharedData.UnacknowledgedConnections[i].status = this.sharedData.UnacknowledgedConnections[i].status.toUpperCase();
        }

        this.refreshIntegrationNotificationsCount();
    }

    // @ts-ignore TS7006
    handleDataChanged(dataChangedEvent) {
        if (dataChangedEvent) this.storesService.dataChanged(dataChangedEvent);
    }

    deregisterEventHandlers() {
        this.notificationService.connection.off('EmailReceived', this.loadUnreadMessagesThrottled);
        this.notificationService.connection.off('EmailRead', this.loadUnreadMessagesThrottled);
        this.notificationService.connection.off('MessageRead', this.loadUnreadMessagesThrottled);
        this.notificationService.connection.off('NotifyMessageSent', this.loadUnreadMessagesThrottled);
        this.notificationService.connection.off('ImportProgressUpdated', this.importProgressUpdatedHandler);
        this.notificationService.connection.off('IncomingConnectionsCountUpdated', this.incomingConnectionsCountUpdatedHandler);
        this.notificationService.connection.off('ClientConnectionsAckUpdated', this.clientConnectionsAckUpdatedHandler);
        this.notificationService.connection.off('DataChanged', this.handleDataChangedHandler);
        this.notificationService.connection.off('LeadsInviteStatusChanged', this.streamChatInitHandler);
    }

    registerEventHandlers() {
        this.notificationService.connection.on('EmailReceived', this.loadUnreadMessagesThrottled);
        this.notificationService.connection.on('EmailRead', this.loadUnreadMessagesThrottled);
        this.notificationService.connection.on('MessageRead', this.loadUnreadMessagesThrottled);
        this.notificationService.connection.on('NotifyMessageSent', this.loadUnreadMessagesThrottled);
        this.notificationService.connection.on('ImportProgressUpdated', this.importProgressUpdatedHandler);
        this.notificationService.connection.on('IncomingConnectionsCountUpdated', this.incomingConnectionsCountUpdatedHandler);
        this.notificationService.connection.on('ClientConnectionsAckUpdated', this.clientConnectionsAckUpdatedHandler);
        this.notificationService.connection.on('DataChanged', this.handleDataChangedHandler);
    }

    // MOBILE VIEW <START>
    setNotificationBadges() {
        if (this.mobileView) {
            this.communicationsOptions = this.sidebar2SubpanelSharedService.getNotificationBadges();
        }
    }

    getDropdownClasses(submenu: string, fixedChevron = false) {
        let classStrings = [];
        const queryParams = this.routerStateService.currentRoute?.queryParams;
        if (queryParams?.submenu === submenu) {
            classStrings = [];
            classStrings.push('active');
            if (this.filterState && this.filterState.submenu === submenu) {
                if (!this.filterState.enabled) classStrings.push('disabled');
            }
            if (queryParams?.open?.toString() === 'true' && !fixedChevron) classStrings.push('open');
        }
        return classStrings.join(' ');
    }

    determineVisibilityOfConnections() {
        if (this.mobileView) {
            this.integrationsActive = this.sidebar2SubpanelSharedService.getVisibilityOfConnections();
        }
    }

    fnToggleIntegrationsConnections() {
        this.toggle_Connections = !this.toggle_Connections;
    }

    toggleMainMenu() {
        this.layoutService.isSidebarClosed = !this.layoutService.isSidebarClosed;
        this.storesService.mobileMenuToggle({ id: 'sidebar2', active: this.layoutService.isSidebarClosed });
    }

    fnSignOut() {
        this.sidebar2SubpanelSharedService.signOut();
    }

    toggle() {
        this.sidebar2toggle.toggleSidebar();
        //when the mininav is toggled, reset the intercom position
        this.intercomService.updateLauncherSettings();
    }

    toggleSeeMore() {
        this.showMore.set(!this.showMore());
        this.settings.sidebarSeeMore = this.showMore();
    }

    setLogoUrl() {
        this.logoUrl = this.sharedData.UserData.tenant?.LogoUrlSmall || this.sharedData.UserData.tenant?.LogoUrl || '';
    }

    private updateShowRfqMenuOption() {
        const rfqCount = this.estimatesService.getQuoteRequestsCount().valueChanges;
        const rfqCreated = this.quoteRequestService.rfqCreated$;
        const subscription = combineLatest([rfqCount, rfqCreated])
            .pipe(untilDestroyed(this))
            .subscribe(([countResult, createTriggered]) => {
                this.showRfqMenuOption = (countResult.data.quoteRequests?.totalCount ?? 0) > 0 || createTriggered;
                if (this.showRfqMenuOption) {
                    subscription.unsubscribe();
                }
            });
    }

    #loadUserAvatarInfo() {
        this.avatarInfo = {
            avatar: this.sharedData.UserData.user.avatar,
            firstName: this.sharedData.UserData.user.FirstName,
            surname: this.sharedData.UserData.user.Surname,
        };
    }
}
